const headerNavLinks = [
  // { href: "/blog", title: "Blog" },
  // { href: "/categories/runway", title: "Runway" },
  { href: "/categories/music", title: "Music" },
  { href: "/categories/development", title: "Dev" },
  { href: "/categories/engineering", title: "Engineering" },
  { href: "/tags", title: "Tags" },
  // { href: "/projects", title: "Projects" },
  { href: "/about", title: "About" },
];

export default headerNavLinks;
